import { IFilter } from '../models/ifilter';
import { ILayerViewModel, ITraceViewModel } from '../models/interfaces';
import { IEcgData } from '../models/iecgdata';
import { IChannel } from '../models/ichannel';
import { AnnotationType } from '@se/models';
import { Appearance } from './appearance';

export class LayerViewModel implements ILayerViewModel {
    // data members

    title: string = '';
    active = false;
    selected = false;
    index = 0;
    translate: string = '';
    appearance: Appearance = new Appearance();
    leadCount: number = 0; // used for arrangement
    // To remove
    channels = new Array<IChannel>();

    constructor(ecgData: IEcgData) {
        this._ecgData = ecgData;
        this._conclusions =
            this._ecgData.originalWaveform.annotations != null
                ? this._ecgData.originalWaveform.annotations
                      .filter((annotation) => annotation.type == AnnotationType.UNFORMATTED_TEXT)
                      .map((annotation) => annotation.name)
                : [];
        this._filters =
            this._ecgData.filters != null && this._ecgData.filters.length > 0
                ? this._ecgData.filters
                : this._ecgData.originalWaveform.filters;
    }

    private _traces = new Array<ITraceViewModel>();

    get traces() {
        return this._traces;
    }

    get visibleTraces() {
        return this._traces.filter((trace) => trace.visible);
    }

    private _referenceTraces = new Array<ITraceViewModel>();

    get referenceTraces() {
        return this._referenceTraces;
    }

    get visibleReferenceTraces() {
        return this._referenceTraces.filter((trace) => trace.visible);
    }

    get drawableTraces() {
        return this._traces.concat(this._referenceTraces).filter((trace) => trace.visible);
    }

    get patient() {
        return this._ecgData.patient;
    }

    get study() {
        return this._ecgData.study;
    }

    private _filters = new Array<IFilter>();

    get filters() {
        return this._filters.filter((filter) => filter.value > '0');
    }

    private _conclusions: Array<string>;

    get conclusions() {
        return this._conclusions;
    }

    private _ecgData: IEcgData;

    // constructor

    get ecgData() {
        return this._ecgData;
    }
}
